<template>
  <section id="mainContent">
    <general-header :headerTitle="$t('Registro de ponto')" :headerIcon="['finger-print-outline']"></general-header>

    <!-- left menu -->
    <left-menu></left-menu>

    <!-- content -->
    <shadow-box  v-if="!loadingInfo" class="point-main-wrapper">

      <div class="point-main-left-box">
        <div class="screen-lock-cache" v-if="showPointCache"></div>
          <!-- web-cam-modal -->
       <div v-if="dataInfo.needPhotoToRegisterInWeb" class="webcam-content">
        <div v-if="dataInfo.needPhotoToRegisterInWeb && haveCam" class="cam">
          <video ref="video" id="video" width="640" height="480" autoplay="true"></video>
          <canvas ref="canvas" id="canvas" width="640" height="480"></canvas>
        </div>
      </div>

        <div v-if="useWorkingLocalUser" class="left-box-title">
         {{$t(" De onde você está trabalhando hoje?")}}
        </div>

        <div v-if="useWorkingLocalUser" class="icons-wrapper">
          <div class="left-box-icons">
            <div class="left-box-locations" @click="addLocationPoint(2)" :class="{'active': dataSendLocationPoint.local === 2}">
              <ion-icon name="home-outline"></ion-icon>
            </div>
            <span>{{$t("Casa")}}</span>
          </div>

          <div class="left-box-icons">
            <div class="left-box-locations" @click="addLocationPoint(1)" :class="{'active': dataSendLocationPoint.local === 1}">
              <ion-icon name="business-outline"></ion-icon>
            </div>
            <span>{{$t("Escritório")}}</span>
          </div>

          <div class="left-box-icons">
            <div class="left-box-locations" @click="addLocationPoint(3)" :class="{'active': dataSendLocationPoint.local === 3}">
              <ion-icon name="storefront-outline"></ion-icon>
            </div>
            <span>{{$t("Outro")}}</span>
          </div>
        </div>


        <div class="content-modal-wrapper" v-if="needException && listException.length">
          <label v-if="!listExceptionLoading" for="reason-select" class="exception-label">{{$t("Selecione o motivo do ponto por exceção")}}<span>*</span></label>
          <select v-if="!listExceptionLoading" name="exception" id="reason-select" v-model="selectedException">
            <option disabled selected></option>
            <option v-for="(exception, index) in listException" :value="exception" :key="index">
              {{ `${exception.name}`}}
            </option>
          </select>
          <dot-loader v-if="listExceptionLoading" id="pause-loader"></dot-loader>
      </div>

      <div class="content-modal-wrapper" v-if="needGadgets && listGadgets.length">
          <label for="reason-select" class="exception-label">{{$t("Selecione em que local você está")}}<span>*</span></label>
          <select name="gadgets" id="reason-select" v-model="selectedGadgets">
            <option disabled selected></option>
            <option v-for="(gadget, index) in listGadgets" :value="gadget" :key="index">
              {{ `${gadget.name}`}}
            </option>
          </select>
      </div>

        <div class="left-menu-register-point-wrapper">
          <button
            class="left-menu-register-point"
            @click="checkDataToRegisterPoint"
            id="register-point-button"
            :disabled="loadingRequest"
            :class="{'register-loader': loadingRequest}"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none" class="register-point">
              <path class="register-point-svg" d="M3.21344 10.2578C3.07642 10.2591 2.94151 10.224 2.82242 10.1562C2.73507 10.1072 2.65838 10.0411 2.59686 9.96203C2.53533 9.88294 2.4902 9.79237 2.46409 9.69562C2.43799 9.59887 2.43145 9.49789 2.44484 9.39858C2.45824 9.29928 2.4913 9.20364 2.54211 9.11727C3.52117 7.48312 6.5 3.66895 13 3.66895C15.8168 3.66895 18.2873 4.40883 20.3394 5.86727C22.0284 7.06418 22.975 8.41902 23.4259 9.07156C23.4831 9.15381 23.5232 9.24668 23.544 9.34468C23.5648 9.44269 23.5657 9.54386 23.5468 9.64223C23.5279 9.74061 23.4894 9.83421 23.4338 9.91751C23.3782 10.0008 23.3064 10.0721 23.2228 10.1273C23.0519 10.2403 22.8437 10.2823 22.6423 10.2444C22.441 10.2064 22.2623 10.0916 22.1442 9.92418C21.3281 8.75062 18.8398 5.17969 13 5.17969C7.2998 5.17969 4.72265 8.46574 3.88324 9.87492C3.81579 9.9926 3.71815 10.0901 3.6004 10.1574C3.48265 10.2248 3.34906 10.2594 3.21344 10.2578Z"/>
              <path class="register-point-svg" d="M16.2749 25.1875C16.2101 25.1883 16.1454 25.1809 16.0824 25.1657C11.3674 23.9977 9.60679 19.2842 9.53519 19.0882L9.52402 19.045C9.48543 18.9089 8.53937 15.6767 9.99172 13.7836C10.6575 12.9203 11.67 12.4775 13.0071 12.4775C14.2502 12.4775 15.147 12.8639 15.7635 13.6637C16.2713 14.3168 16.4745 15.1221 16.671 15.8981C17.0838 17.5139 17.3819 18.3625 19.0978 18.4498C19.8514 18.4879 20.3465 18.0471 20.6273 17.6719C21.3865 16.6486 21.5186 14.9805 20.9462 13.5078C20.2109 11.6071 17.6013 8.02344 13 8.02344C11.0358 8.02344 9.23101 8.65465 7.78375 9.8409C6.58582 10.8235 5.63672 12.2109 5.17969 13.6368C4.33215 16.2916 5.44375 20.4648 5.45441 20.5029C5.48037 20.6001 5.48661 20.7014 5.47278 20.801C5.45895 20.9005 5.42532 20.9963 5.37387 21.0827C5.32242 21.1691 5.25421 21.2443 5.17324 21.3039C5.09227 21.3635 5.00018 21.4062 4.90242 21.4297C4.70491 21.4822 4.49469 21.4553 4.3168 21.3547C4.13892 21.254 4.00752 21.0877 3.95078 20.8914C3.9 20.701 2.71273 16.25 3.69179 13.1818C4.7582 9.85715 8.04933 6.50558 13.0015 6.50558C15.2902 6.50558 17.4525 7.28355 19.2573 8.75266C20.6548 9.89523 21.7963 11.4298 22.3935 12.9639C23.1527 14.9226 22.9491 17.1209 21.8761 18.557C21.1611 19.5147 20.1429 20.0154 19.015 19.9611C16.0768 19.8138 15.5487 17.7628 15.1638 16.2668C14.7677 14.7321 14.5143 13.9923 13.0015 13.9923C12.1707 13.9923 11.5873 14.2208 11.2242 14.6941C10.7291 15.3415 10.6905 16.3536 10.7453 17.0879C10.7813 17.5995 10.8681 18.1062 11.0043 18.6007C11.1252 18.9054 12.6989 22.7647 16.4679 23.6986C16.5653 23.7217 16.6571 23.7639 16.7381 23.8228C16.8191 23.8816 16.8875 23.956 16.9395 24.0416C16.9915 24.1272 17.0259 24.2222 17.0408 24.3212C17.0558 24.4202 17.0509 24.5212 17.0264 24.6182C16.9805 24.7821 16.8821 24.9265 16.7464 25.0293C16.6107 25.1321 16.4451 25.1876 16.2749 25.1875Z"/>
              <path class="register-point-svg" d="M10.2228 24.8391C10.1171 24.8394 10.0125 24.8183 9.91508 24.7772C9.81772 24.7361 9.72963 24.6758 9.65606 24.6C7.76903 22.6195 6.7016 20.4049 6.29992 17.6358V17.6211C6.07446 15.7879 6.40453 13.1925 8.02192 11.408C9.21578 10.0912 10.8941 9.42195 13.0015 9.42195C15.4939 9.42195 17.4525 10.5808 18.6738 12.7679C19.5599 14.3569 19.7356 15.9402 19.7402 16.0052C19.7495 16.1055 19.7389 16.2065 19.7091 16.3026C19.6793 16.3988 19.6308 16.4881 19.5664 16.5654C19.502 16.6428 19.423 16.7067 19.3339 16.7535C19.2447 16.8003 19.1473 16.829 19.047 16.838C18.8448 16.86 18.642 16.8015 18.4825 16.6753C18.323 16.549 18.2195 16.3651 18.1944 16.1632C18.0607 15.2131 17.7532 14.2958 17.2875 13.457C16.3409 11.7868 14.9007 10.9378 12.9959 10.9378C11.3506 10.9378 10.0633 11.4329 9.1777 12.4104C7.90106 13.8196 7.65426 15.9905 7.82946 17.4266C8.18137 19.8753 9.12235 21.8232 10.7839 23.564C10.8533 23.6362 10.9074 23.7215 10.9431 23.815C10.9788 23.9085 10.9953 24.0082 10.9917 24.1082C10.9881 24.2082 10.9645 24.3065 10.9221 24.3971C10.8798 24.4878 10.8197 24.569 10.7453 24.636C10.6021 24.7658 10.416 24.8381 10.2228 24.8391Z" />
              <path class="register-point-svg" d="M18.916 22.6576C17.2656 22.6576 15.8625 22.2005 14.7398 21.2921C12.4841 19.4746 12.2312 16.5146 12.22 16.3896C12.2041 16.1846 12.2703 15.9816 12.4041 15.8254C12.5378 15.6692 12.7282 15.5725 12.9332 15.5566C13.1383 15.5407 13.3412 15.6069 13.4975 15.7407C13.6537 15.8744 13.7504 16.0648 13.7663 16.2698C13.7719 16.3135 13.9973 18.7347 15.7361 20.1292C16.7649 20.9508 18.1401 21.2768 19.8346 21.0864C20.0372 21.0618 20.2412 21.1185 20.4021 21.2439C20.563 21.3693 20.6677 21.5533 20.6934 21.7557C20.7044 21.8557 20.6955 21.9569 20.6671 22.0534C20.6387 22.1499 20.5913 22.2397 20.5278 22.3177C20.4642 22.3957 20.3858 22.4603 20.2971 22.5076C20.2083 22.555 20.111 22.5842 20.0109 22.5936C19.6474 22.636 19.2819 22.6574 18.916 22.6576ZM20.2201 2.47762C19.5762 2.05867 17.293 0.8125 13 0.8125C8.49367 0.8125 6.20496 2.18918 5.69867 2.53906C5.66523 2.55959 5.63393 2.5834 5.60523 2.61016C5.60221 2.61309 5.59826 2.61488 5.59406 2.61523C5.51322 2.68582 5.44834 2.77283 5.40377 2.87047C5.3592 2.9681 5.33596 3.07412 5.33559 3.18145C5.33698 3.28205 5.3582 3.3814 5.39805 3.47378C5.4379 3.56617 5.49559 3.64979 5.56782 3.71984C5.64004 3.7899 5.72538 3.84501 5.81894 3.88202C5.9125 3.91904 6.01244 3.93723 6.11305 3.93555C6.2743 3.93544 6.43165 3.886 6.56398 3.79387C6.58582 3.77762 8.55562 2.33035 13.0015 2.33035C17.4474 2.33035 19.4279 3.77254 19.4492 3.7832C19.5844 3.88346 19.7486 3.93694 19.9169 3.93555C20.0176 3.93709 20.1176 3.91874 20.2112 3.88153C20.3048 3.84433 20.3901 3.78902 20.4622 3.71876C20.5343 3.64851 20.5919 3.5647 20.6316 3.47214C20.6712 3.37958 20.6922 3.28011 20.6934 3.17941C20.6934 3.02859 20.6484 2.88119 20.564 2.75614C20.4797 2.63109 20.3599 2.5341 20.2201 2.47762Z"/>
            </svg>
            <div  class="register-point-text">
              {{$t("Marcar Ponto")}}
            </div>

          </button>
        </div>
      </div>

      <div class="mid-line">
       <svg xmlns="http://www.w3.org/2000/svg" width="2" height="409" viewBox="0 0 2 409" fill="none">
          <path d="M1 0L1.00002 409" stroke="var(--border)"/>
        </svg>
      </div>

      <div class="point-main-right-box">
        <span class="title">{{$t("Último ponto")}}</span>
        <span class="last-point">{{ `${dataInfo.lastPoint.split(" ")[0]} às ${dataInfo.lastPoint.split(" ")[1]}`}}</span>

        <div class="point-cache-wrapper" v-if="showPointCache">
          <svg id="hourglass-point" width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.9349 44.4062H35.0642C36.9591 44.4062 38.4664 42.8472 38.2626 41.0509C36.9467 29.4766 29.0933 29.668 29.0933 24.5C29.0933 19.332 37.0472 19.6191 38.2616 7.9491C38.453 6.1518 36.9591 4.59375 35.0642 4.59375H13.9349C12.0399 4.59375 10.5498 6.1518 10.7374 7.9491C11.9519 19.6191 19.9058 19.2363 19.9058 24.5C19.9058 29.7637 12.0524 29.4766 10.7374 41.0509C10.5326 42.8472 12.0399 44.4062 13.9349 44.4062Z" stroke="#1B59F8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M32.8553 41.3438H16.1867C14.6937 41.3438 14.2727 39.6211 15.3196 38.553C17.8539 35.9844 22.9692 34.145 22.9692 31.1992V21.4375C22.9692 19.5378 19.3325 18.0879 17.0825 15.0063C16.7112 14.4981 16.7485 13.7812 17.6921 13.7812H31.3518C32.1567 13.7812 32.3309 14.4923 31.9643 15.0015C29.7469 18.0879 26.0317 19.5282 26.0317 21.4375V31.1992C26.0317 34.121 31.3633 35.6973 33.7262 38.5559C34.6785 39.7082 34.3454 41.3438 32.8553 41.3438Z" fill="#1B59F8" fill-opacity="0.4"/>
          </svg>

          <span>{{$t("Ponto em processamento")}}</span>
          <span>{{$t("Seu ponto das")}}<span>{{ this.dateLastPoint.lastDatePoint | formatHours }}</span>{{$t("já foi registrado!")}}</span>
          <span>{{$t("Atualize a página para visualizar o ponto.")}}</span>

          <button @click="reloadPage()">
            <ion-icon name="refresh"></ion-icon>
            {{$t("Atualizar página")}}
          </button>
        </div>


        <div class="circle-progress-bar-wrapper" v-if="!showPointCache">
          <div class="outer-bar">
            <div class="inner-bar">
              <span>{{$t("Horas trabalhadas")}}</span>
              <span>{{ dataInfo.workedHours }}</span>
            </div>
          </div>

          <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="186px" height="186px">
            <defs>
                <linearGradient id="GradientColor">
                  <stop offset="0%" stop-color="var(--darkBlue)" />
                  <stop offset="100%" stop-color="var(--darkBlue)" />
                  <animate attributeName="fy" dur="100ms" from="0%" to="100%" repeatCount="indefinite" />
                </linearGradient>
            </defs>
            <circle cx="93" cy="93" r="84" stroke-linecap="round" :style="{'stroke-dashoffset': this.calculateCircunferenceOffSet(527.52, workedPercentage)}" />
          </svg>
        </div>

        <div class="bottom-messages-wrapper" v-if="!showPointCache">
            <div class="first-line">
              <div>
                <ion-icon name="alarm-outline"></ion-icon>
                <span>{{$t("Seu turno está registrado como ")}}{{ this.dataInfo.workshiftName}}</span>
              </div>
              <div class="journey-wrapper" v-if="dataInfo && dataInfo.journeyTimes">
                <span id="workshift-times">{{dataInfo.journeyTimes}}</span>
              </div>
            </div>

            <div class="second-line" v-if="workShiftType !== 4">
              <ion-icon name="cloudy-night-outline"></ion-icon>
              <span>{{ dataInfo.text }}</span>
            </div>
        </div>
      </div>
    </shadow-box>

    <div class="screen-lock-main-content" v-if="loadingRequest && !isFiveMinutesModalOpened"></div>
    <div class="screen-lock-left-menu" v-if="loadingRequest && !isFiveMinutesModalOpened"></div>
    <screen-lock-loader v-if="loadingRequest && !isFiveMinutesModalOpened"></screen-lock-loader>

    <dot-loader v-if="loadingInfo"></dot-loader>

    <confirmation-modal
      v-if="showBlockPage"
      :titleIcon="['walk-outline']"
      :title="$t('Parece que você ficou ausente')"
      :confirmButtonText="$t('Atualizar página')"
      id="block-modal"
      @close-modal="refreshPage"
      :methodHandler="refreshPage"
      :canClose="true"
    >

      <ion-icon name="walk-outline" id="icon-walk"></ion-icon>
      <span>
        {{$t("Você não interagiu com essa página por mais de 2 minutos. Clique no botão para atualizar a página.")}}
      </span>
    </confirmation-modal>

    <confirmation-modal
      v-if="isFiveMinutesModalOpened"
      :titleIcon="['alert-circle-outline']"
      :title="$t('Marcar ponto novamente?')"
      :confirmButtonText="$t('Sim, continuar')"
      :cancelButtonText="$t('Cancelar')"
      id="five-minutes-modal"
      :canClose="true"
      @close-modal="v => handleCloseModal(v)"
      :methodHandler="sendPointNew"
    >

      <div class="five-minutes-wrapper">
        <ion-icon v-if="!loadingRequest" name="alert-circle-outline"></ion-icon>
        <span v-if="!loadingRequest">{{$t("Houve um registro a menos de 5 minutos ")}}({{ dataInfo.lastPoint.split(" ")[1] }})</span>
        <dot-loader v-if="loadingRequest" id="five-minutes-loader"></dot-loader>
      </div>
    </confirmation-modal>

    <confirmation-modal
      v-if="isVacationModalOpened"
      :titleIcon="['airplane-outline']"
      :title="$t('Marcar ponto em afastamento')"
      :confirmButtonText="$t('Sim, continuar')"
      :cancelButtonText="$t('Cancelar')"
      id="vacation-modal"
      :canClose="true"
      @close-modal="v => handleCloseModal(v)"
      :methodHandler="sendPointNew"
    >
      <ion-icon name="airplane-outline"></ion-icon>
      <div id="vacation-text-wrapper">
        <span>{{$t("Você possui um afastamento hoje:")}} ({{ dataInfo.lastPoint.split(" ")[0] }}).</span>
        <span>{{$t("Tem certeza que deseja marcar seu ponto")}}</span>
      </div>
    </confirmation-modal>

    <div class="modal fade" id="modalWorkShift" role="dialog">
      <div class="modal-dialog modal-dialog-35">
        <!-- Modal content-->
        <div class="modal-content modal-workshift">
          <div class="modal-header">
            <button type="button" class="close" @click="closeModal()" data-dismiss="modal">&times;</button>
            <ion-icon name="finger-print"></ion-icon>
            <span>{{$t("Selecione qual ponto você deseja marcar:")}}</span>
          </div>
          <div class="modal-body">
            <div class="body-content">
              <div @click="setTurnSelected(1)" class="content-btn point-entrance" :style="turnSelected === 1 ? 'background: #2ACC6B;' : ''">
                <span v-if="dataInfo.lastPointRegisterType === 1" class="last-point">Último ponto</span>
                <div :style="turnSelected === 1 ? 'color: #FFFFFF;' : ''" class="btn-text">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :style="turnSelected === 1 ? 'fill: #FFFFFF;' : ''" d="M10.09 15.59L11.5 17L16.5 12L11.5 7L10.09 8.41L12.67 11H3V13H12.67L10.09 15.59ZM19 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V9H5V5H19V19H5V15H3V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z" fill="#2ACC6B"/>
                  </svg>
                  {{$t("Entrada")}}
                </div>
                <span :style="turnSelected === 1 ? 'color: #FFFFFF;' : ''" v-if="dataInfo.lastPointRegisterType === 1" class="last-appointment">
                  <span class="last-day">{{dataInfo.lastPointDate }}</span>
                  <span class="last-hour">{{dataInfo.lastPointHour }}</span>
                </span>
              </div>
              <div @click="setTurnSelected(2)" class="content-btn point-exit-interval" :style="turnSelected === 2 ? 'background: #FF9900;' : ''">
                <span v-if="dataInfo.lastPointRegisterType === 2" class="last-point">{{$t("Último ponto")}}</span>
                <div :style="turnSelected === 2 ? 'color: #FFFFFF;' : ''" class="btn-text">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :style="turnSelected === 2 ? 'fill: #FFFFFF;' : ''" d="M9.25 16.25H11.25V8.25H9.25V16.25ZM12.25 2.25C6.73 2.25 2.25 6.73 2.25 12.25C2.25 17.77 6.73 22.25 12.25 22.25C17.77 22.25 22.25 17.77 22.25 12.25C22.25 6.73 17.77 2.25 12.25 2.25ZM12.25 20.25C7.84 20.25 4.25 16.66 4.25 12.25C4.25 7.84 7.84 4.25 12.25 4.25C16.66 4.25 20.25 7.84 20.25 12.25C20.25 16.66 16.66 20.25 12.25 20.25ZM13.25 16.25H15.25V8.25H13.25V16.25Z" fill="#FF9900"/>
                  </svg>
                  {{$t("Saída intervalo")}}
                </div>
                <span :style="turnSelected === 2 ? 'color: #FFFFFF;' : ''" v-if="dataInfo.lastPointRegisterType === 2" class="last-appointment">
                  <span class="last-day">{{dataInfo.lastPointDate }}</span>
                  <span class="last-hour">{{dataInfo.lastPointHour }}</span>
                </span>
              </div>
              <div @click="setTurnSelected(3)" class="content-btn btn-back-interval" :style="turnSelected === 3 ? 'background: #2F23D6;' : ''">
                <span v-if="dataInfo.lastPointRegisterType === 3" class="last-point">{{$t("Último ponto")}}</span>
                <div :style="turnSelected === 3 ? 'color: #FFFFFF;' : ''" class="btn-text">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :style="turnSelected === 3 ? 'fill: #FFFFFF;' : ''" d="M10.5 16.5L16.5 12L10.5 7.5V16.5ZM12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20Z" fill="#2F23D6"/>
                  </svg>
                  {{$t("Volta intervalo")}}
                </div>
                <span :style="turnSelected === 3 ? 'color: #FFFFFF;' : ''" v-if="dataInfo.lastPointRegisterType === 3" class="last-appointment">
                  <span class="last-day">{{dataInfo.lastPointDate }}</span>
                  <span class="last-hour">{{dataInfo.lastPointHour }}</span>
                </span>
              </div>
              <div @click="setTurnSelected(4)" class="content-btn point-exit" :style="turnSelected === 4 ? 'background: #FF445D;' : ''">
                <span v-if="dataInfo.lastPointRegisterType === 4" class="last-point">{{$t("Último ponto")}}</span>
                <div :style="turnSelected === 4 ? 'color: #FFFFFF;' : ''" class="btn-text">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path :style="turnSelected === 4 ? 'fill: #FFFFFF;' : ''" d="M14.41 8.41L13 7L8 12L13 17L14.41 15.59L11.83 13L21.5 13L21.5 11L11.83 11L14.41 8.41ZM5.5 21L19.5 21C20.0304 21 20.5391 20.7893 20.9142 20.4142C21.2893 20.0391 21.5 19.5304 21.5 19L21.5 15L19.5 15L19.5 19L5.5 19L5.5 5L19.5 5L19.5 9L21.5 9L21.5 5C21.5 4.46957 21.2893 3.96086 20.9142 3.58579C20.5391 3.21071 20.0304 3 19.5 3L5.5 3C4.4 3 3.5 3.9 3.5 5L3.5 19C3.5 20.1 4.4 21 5.5 21Z" fill="#FF445D"/>
                  </svg>
                  Saída
                </div>
                <span :style="turnSelected === 4 ? 'color: #FFFFFF;' : ''" v-if="dataInfo.lastPointRegisterType === 4" class="last-appointment">
                  <span class="last-day">{{dataInfo.lastPointDate }}</span>
                  <span class="last-hour">{{dataInfo.lastPointHour }}</span>
                </span>
              </div>
            </div>
            <div class="footer-content">
              <div v-if="dataInfo.lastPointRegisterType === turnSelected && dataInfo.lastPointRegisterType === 1" class="point-repeat">{{$t("Seu último ponto foi uma entrada, tem certeza que deseja marcar novamente?")}}</div>
              <div v-if="dataInfo.lastPointRegisterType === turnSelected && dataInfo.lastPointRegisterType === 2" class="point-repeat">{{$t("Seu último ponto foi uma saída intevalo, tem certeza que deseja marcar novamente?")}}</div>
              <div v-if="dataInfo.lastPointRegisterType === turnSelected && dataInfo.lastPointRegisterType === 3" class="point-repeat">{{$t("Seu último ponto foi uma volta intervalo, tem certeza que deseja marcar novamente?")}}</div>
              <div v-if="dataInfo.lastPointRegisterType === turnSelected && dataInfo.lastPointRegisterType === 4" class="point-repeat">{{$t("Seu último ponto foi uma saída, tem certeza que deseja marcar novamente?")}}</div>
              <div class="content-btn">
                <span @click="closeModal()" class="btn-cancel">{{$t("Cancelar")}}</span>
                <button v-on:click="confirmPoint()" class="btn-confirm" :disabled="turnSelected === 0 || turnSelected === ''">
                  <ion-icon name="finger-print"></ion-icon>
                  {{$t("Confirmar")}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import {
  NEW_REGISTER_POINT,
  POINT_DAY_DETAIL,
  SEND_BUG,
  TIMER,
  WORKING_LOCAL_EMPLOYEE,
  WORKING_LOCAL_EMPLOYEE_TODAY,
  GET_EXCEPTION,
} from "../../../../urlConfig";
import { REQUEST_SERVICE } from "../../../../requestConfig";
import { UTIL_SERVICE } from "../../../../utils";
import moment from 'moment'
import swal from 'sweetalert';
import leftMenu from '../../components/leftMenu.vue'
import shadowBox from '../../components/layouts/shadowBox.vue';
import confirmationModal from '../../components/confirmationModal.vue';
import dotLoader from "../../components/dotLoader.vue";
import generalHeader from "../../components/layouts/generalHeader.vue";
import screenLockLoader from '../../components/screenLockLoader.vue';

  export default {
    components: {
      leftMenu,
      shadowBox,
      confirmationModal,
      dotLoader,
      generalHeader,
      screenLockLoader
    },
    name: 'newPoint',
    data() {
      return {
        showPointCache: false,
        isVacationModalOpened: false,
        isFiveMinutesModalOpened: false,
        isNoticesOpened: false,
        hasNotification: '',
        noticesLoader: false,
        useWorkingLocalUser: true,
        notices: [],
        workedHours: '',
        workedPercentage: 0,
        listExceptionLoading: false,
        turnSelected: '',
        width: '100%',
        timerBlockPage: 1,
        showBlockPage: false,
        needGadgets: false,
        needException: false,
        listGadgets: [],
        listException: [],
        selectedGadgets: '',
        selectedException: '',
        dataSendError: '',
        dataSendFeeling: {
          mood: '',
          comment: '',
          eDeviceType: 3
        },
        dataSendLocationPoint: {
          local: '',
        },
        showFeelingsDay: false,
        historyListPoints: null,
        dataAuthInfo: {},
        geoC: {
          latitude: '',
          longitude: '',
          elevation: ''
        },
        dataUserInfo: {},
        homeCtrl: null,
        dateLastPoint: null,
        isDark: null,
        showPause: false,
        loadingInfo: false,
        loadingSendPoint: false,
        loadingRequest: false,
        haveCam: true,
        currentTime: "",
        currentDateTime: "",
        captures: "",
        stream: "",
        dataWebCam: "",
        video: {},
        canvas: {},
        dataRegister: {},
        dataInfo: {},
        route: "",
        dataWork: {
          dayTotalSeconds: '',
          dayProgressSeconds: '',
          dayHours: "00:00"
        },
        myIntervals: {
          updateCurrentTime: null,
          updateProgressAndHoursWorking: null
        },
        workShiftType: 0,
        oneClick: false
      }
    },
    beforeMount() {
      const dataConfigProgressPoint = UTIL_SERVICE.getStorage('configProgressPoint');
      const userAccess = UTIL_SERVICE.getStorage('userAccess');

      if (userAccess) {
        this.useWorkingLocalUser = userAccess.useWorkingLocalUser;
      }

      try {
        if (dataConfigProgressPoint.fromDay !== moment(new Date()).format('DD/MM/YYYY')) {
        UTIL_SERVICE.saveStorage('configProgressPoint',{
          totalPoint: 0,
          newPointRegister: 0,
          fromDay: moment(new Date()).format('DD/MM/YYYY')
        });
      }
      } catch (error) {
        console.error(error)
      }
      try {
        this.dataAuthInfo = UTIL_SERVICE.getStorage('authUser');
        this.dataUserInfo = UTIL_SERVICE.getStorage('userInfo');
      } catch (e) {}
      try {
        const dateLastPoint = UTIL_SERVICE.getStorage('dataDateLastPoint');
        if (dateLastPoint) {
          this.dateLastPoint.dateLastPoint = dateLastPoint.date;
        } else {
          this.dateLastPoint = UTIL_SERVICE.getStorage('dateLastPointConfirm');
        }
      } catch (e) {
        this.dateLastPoint = UTIL_SERVICE.getStorage('dateLastPointConfirm');
      }

      try {
        let chooseTheme = JSON.parse(window.localStorage.getItem('darkMode'));
        if (chooseTheme) {
          this.isDark = JSON.parse(window.localStorage.getItem('darkMode')).dark;
        }
      } catch (e) {}

      // Remove storage
      window.localStorage.removeItem("dataConfirmPoint");

      // Check show feelings
      let dataFeeling = UTIL_SERVICE.getStorage('showFeelings');
      if (dataFeeling) this.showFeelingsDay = dataFeeling.feelings;

      if (JSON.parse(window.localStorage.getItem('userInfo')).company.id === '2C25B65430F649E0BAD4A55C67B3FD7C')
        this.showFeelingsDay = false;

      // Check Pause
      this.showPause = JSON.parse(window.localStorage.getItem('userInfo')).company.isUsingPause;

      try {
        this.workShiftType = this.dataUserInfo.workShift.workShiftType;
      } catch (e) {}

      moment.locale('pt-br');

      this.pointInfo();

      this.getListException()

      let dataConfigMenu = UTIL_SERVICE.getStorage('configMenu');
      let dataUserInfo = UTIL_SERVICE.getStorage('userInfo');

      try {
        if (dataUserInfo.company) {
          if (dataUserInfo.company.hasLocation) {
            this.needGadgets = true;
            this.listGadgets = [];
            this.listGadgets = dataUserInfo.company.locations;
          }
        }

        if(dataUserInfo.company.sporadic) {
          this.needException = dataUserInfo.company.sporadic
        }
      } catch (e) {}

      try {
        if (dataConfigMenu) {
          if (dataConfigMenu.hasLocation) {
            this.needGadgets = true;
            this.listGadgets = [];
            this.listGadgets = dataConfigMenu.locations;
          }
        }
      } catch (e) {}

      this.getWorkingLocalToday();

      setInterval(() => this.cancelMainLoading(), 12000)
    },
    methods: {
      stopVideoOnly(stream) {
        if(stream) {
          stream.getTracks().forEach((track) => {
            if (track.readyState == 'live' && track.kind === 'video') {
                track.stop();
            }
          });
        }
      },
      reloadPage() {
        UTIL_SERVICE.historyLog(false, window.location.pathname, 'realodPage', {realodProcess: true}, false, null);
        window.location.reload();
      },
      handleCloseModal(value) {
        this.isFiveMinutesModalOpened = value;
      },
      showMessageHoliday() {
        this.isVacationModalOpened = true;
        this.oneClick = false;

      },
      // checkDateHoursFromLastPoint() {
      //   if (this.currentDateTime) {
      //     const lastPoint = new moment(new Date(this.dateLastPoint.lastDatePoint)).add(5, 'm').toDate();
      //     const currentDate = new Date(this.currentDateTime);
      //
      //     if (currentDate.getTime() > lastPoint.getTime()) {
      //       if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
      //         this.showMessageHoliday();
      //       } else {
      //         this.sendPointNew();
      //       }
      //     } else {
      //       this.showMessage5Minutes();
      //     }
      //   } else {
      //     const lastPoint = new moment(new Date(this.dateLastPoint.lastDatePoint)).add(5, 'm').toDate();
      //     const currentDate = new Date();
      //
      //     if (currentDate.getTime() > lastPoint.getTime()) {
      //       if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
      //         this.showMessageHoliday();
      //       } else {
      //         this.sendPointNew();
      //       }
      //     } else {
      //       this.showMessage5Minutes();
      //     }
      //   }
      // },
      checkDataToRegisterPoint() {
        this.dataSendError = '';
        if (this.workShiftType === 4) {
          if (this.needGadgets && !this.selectedGadgets && this.listGadgets.length > 0) {
              this.loadingRequest = false;
              this.dataSendError = this.$t("Selecione o local que você está para marcar seu ponto.");
              this.$toast.error(this.dataSendError)
              this.oneClick = false
              return '';

          }

          if (this.needException) {
            if (this.selectedException) {
              $('#modalWorkShift').modal();
            } else {
              if (this.listException.length > 0) {
                this.loadingRequest = false;
                this.dataSendError = this.$t("Selecione o motivo do ponto por exceção para marcar seu ponto.");
                this.$toast.error(this.dataSendError)
                this.oneClick = false
                return '';
              }
            }
          }

          $('#modalWorkShift').modal();
        } else {
          if (this.dateLastPoint) {
            if (this.dateLastPoint.lastDatePoint) {
              this.checkDateHoursFromLastPoint();
            } else {
              if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
                this.showMessageHoliday();
              } else {
                this.sendPointNew();
              }
            }
          } else {
            if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
              this.showMessageHoliday();
            } else {
              this.sendPointNew();
            }
          }
        }
      },
      addLocationPoint(value) {
        if (!this.loadingRequest) {
          this.dataSendLocationPoint.local = value;
        }
      },
      sendPointNew() {
        if (this.loadingRequest === false) {
          this.loadingRequest = true;

          this.dataSendError = '';
          try {
            this.historyListPoints = UTIL_SERVICE.getStorage('historyListPoints');
            this.historyListPoints.hasNotification = true;

            if (this.historyListPoints.list.length >= 10) this.historyListPoints.list.splice(this.historyListPoints.list.length - 1, 1);
          } catch (err) {
            console.log(err.message);
          }

          try {
            this.homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
            this.homeCtrl.resetPoints = true;
          } catch(err) {
            console.log(err.message);
          }

          const bodyRegisterPoint = {
            fromWhere: "",
            geoC: {},
            device: {
              id: '',
              model: '',
              appVersion: '',
              type: ''
            },
            image: {},
            aditionalInfo: {
              contextCode: '',
              online: true
            },
            userId: '',
            companyId: '',
            date: ''
          };


          if (this.workShiftType === 4) {
            bodyRegisterPoint.aditionalInfo.pointRegisterType = this.turnSelected;
          }

          if (this.needGadgets) {
            if (this.selectedGadgets) {
              bodyRegisterPoint.aditionalInfo.locationId = this.selectedGadgets.id;
            } else {
              if (this.listGadgets.length > 0) {
                this.loadingRequest = false;
                this.dataSendError = this.$t("Selecione o local que você está para marcar seu ponto.");
                this.$toast.error(this.dataSendError)
                this.oneClick = false
                return '';
              }
            }
          }
          if (this.needException) {
            if (this.selectedException) {
              bodyRegisterPoint.aditionalInfo.sporadicCategoryId = this.selectedException.id;
            } else {
              if (this.listException.length > 0) {
                this.loadingRequest = false;
                this.dataSendError = this.$t("Selecione o motivo do ponto por exceção para marcar seu ponto.");
                this.$toast.error(this.dataSendError)
                this.oneClick = false
                return '';
              }
            }
          }

          this.$toast(this.$t("Aguarde um instante que logo seu ponto será confirmado!"), {
            position: "top-center",
            timeout: 3000,
            pauseOnHover: false,
            closeButton: "button",
          })

          if (this.dataInfo.needLocationToModePointWeb) {
            if (this.geoC.latitude || this.geoC.longitude) {
              bodyRegisterPoint.geoC.latitude = this.geoC.latitude;
              bodyRegisterPoint.geoC.longitude = this.geoC.longitude;
              bodyRegisterPoint.geoC.elevation = this.geoC.altitude;
            } else {
              const dataLocation = new Promise(function (resolve, reject) {
                if (navigator.geolocation) {
                  navigator.geolocation.getCurrentPosition(resolve, reject, {
                    enableHighAccuracy: true,
                    timeout: 60000,
                    maximumAge: 0
                  });
                } else {
                  reject({doestSupport: true});
                }
              });

              dataLocation.then((response) => {
                bodyRegisterPoint.geoC.latitude = response.coords.latitude;
                bodyRegisterPoint.geoC.longitude = response.coords.longitude;
                bodyRegisterPoint.geoC.elevation = response.coords.altitude;
              }).catch(reason => {
                // this.loadingRequest = false;

                delete this.dataRegister.baseImage;
                UTIL_SERVICE.historyLog(false, window.location.pathname, 'checkPosition', this.dataRegister, true, reason);

                if (reason.doestSupport) {
                  $("#modalDontSupport").modal();

                  try {
                    let browserInfo = UTIL_SERVICE.checkBrowser();
                    let objSend = {};
                    objSend.text = `Browser not support location, open modal alert update browser.`;
                    objSend.subject = "99";
                    objSend.userId = JSON.parse(window.localStorage.getItem('userInfo')).id;
                    objSend.deviceModel = browserInfo.name;
                    objSend.version = browserInfo.version;
                    objSend.deviceType = "3";
                    REQUEST_SERVICE.post(SEND_BUG, objSend).then((response) => {
                      UTIL_SERVICE.console("RESULT :", response.data);
                    });
                  } catch (e) {}
                } else {

                  try {
                    let browserInfo = UTIL_SERVICE.checkBrowser();
                    let objSend = {};
                    objSend.text = `COD: ${reason.code}, MESSAGE: ${reason.message}, PERMISSION_DENIED: ${reason.PERMISSION_DENIED}, POSITION_UNAVAILABLE: ${reason.POSITION_UNAVAILABLE}, TIMEOUT: ${reason.TIMEOUT}`;
                    objSend.subject = "99";
                    objSend.userId = JSON.parse(window.localStorage.getItem('userInfo')).id;
                    objSend.deviceModel = browserInfo.name;
                    objSend.version = browserInfo.version;
                    objSend.deviceType = "3";
                    REQUEST_SERVICE.post(SEND_BUG, objSend).then((response) => {
                      UTIL_SERVICE.console("RESULT :", response.data);
                    });
                  } catch (e) {}

                  switch (reason.code) {
                    case 1:
                      // swal("Aviso", "Usuário rejeitou a solicitação de Geolocalização.", "error");
                      this.$toast.error(this.$t("Usuário rejeitou a solicitação de Geolocalização."))
                      break;
                    default:

                      break;
                  }
                }
              });
            }
          }

          setTimeout(() => {
            // Get Browser Info
            try {
              let browserInfo = UTIL_SERVICE.checkBrowser();
              bodyRegisterPoint.device.model = browserInfo.name;
              bodyRegisterPoint.device.appVersion = browserInfo.version;
            } catch (err) {
              this.$toast.error(err.message);
            }

            // Get web cam image.
            try {
              if (this.dataInfo.needPhotoToRegisterInWeb && this.haveCam) {
                this.canvas = this.$refs.canvas;
                let context = this.canvas.getContext("2d").drawImage(video, 0, 0, 640, 480);
                this.captures = canvas.toDataURL("image/png");
                bodyRegisterPoint.image.imageBase64 = this.captures;
              }
            } catch (err) {
              this.$toast.error(err.message);
            }

            if (this.currentDateTime) {
              bodyRegisterPoint.date = moment(this.currentDateTime, "YYYYMMDD HH:mm").format();
            } else {
              bodyRegisterPoint.date = moment(new Date(), "YYYYMMDD HH:mm").format();
            }

            bodyRegisterPoint.device.type = "3";
            bodyRegisterPoint.fromWhere = 'Web';
            bodyRegisterPoint.aditionalInfo.online = true;
            bodyRegisterPoint.userId = this.dataUserInfo.id;
            bodyRegisterPoint.companyId = this.dataUserInfo.companyId;
            bodyRegisterPoint.aditionalInfo.contextCode = this.dataAuthInfo.userContentSetting;
            bodyRegisterPoint.device.id = UTIL_SERVICE.getStorage('browserId');

            let url = NEW_REGISTER_POINT;

            UTIL_SERVICE.console("DATA SEND:", bodyRegisterPoint);
            REQUEST_SERVICE.post(url, bodyRegisterPoint).then((response) => {
              UTIL_SERVICE.console("RESULT REGISTER_POINT registerWithLocation:", response.data);
              if (response.data.succeed) {
                try {

                  const dataConfigProgressPoint = UTIL_SERVICE.getStorage('configProgressPoint');

                  if (dataConfigProgressPoint.fromDay !== moment(new Date()).format('DD/MM/YYYY')) {
                    UTIL_SERVICE.saveStorage('configProgressPoint',{
                      totalPoint: 1,
                      newPointRegister: 0,
                      fromDay: moment(new Date()).format('DD/MM/YYYY')
                    });
                  } else {
                    let totalPoint = dataConfigProgressPoint.totalPoint + 1;
                    UTIL_SERVICE.saveStorage('configProgressPoint',{
                      totalPoint: dataConfigProgressPoint.totalPoint,
                      newPointRegister: totalPoint,
                      fromDay: moment(new Date()).format('DD/MM/YYYY')
                    });
                  }
                } catch (e) {}

                // if (this.showFeelingsDay) {
                //   this.sendFeelings();
                // }

                this.loadingRequest = false;

                try {
                  clearInterval(this.myIntervals.updateCurrentTime);
                  clearInterval(this.myIntervals.updateProgressAndHoursWorking);
                  this.stream.getTracks()[0].stop();
                } catch (e) {}

                // Reset storage history
                this.historyListPoints.list.unshift({text: 'Ponto registrado as: ', date: response.data.finishedAt, type: 1});
                UTIL_SERVICE.saveStorage('historyListPoints', this.historyListPoints);
                UTIL_SERVICE.saveStorage('homeCtrl', this.homeCtrl);
                UTIL_SERVICE.saveStorage('pointHistoryCtrl', {
                  getRequest: true,
                  controlBy4Hours: null,
                  dateAtt: null,
                  initDate: null,
                  endDate: null,
                  listHistory: []
                });

                try { UTIL_SERVICE.saveStorage('dateLastPointConfirm', {lastDatePoint: response.data.finishedAt, showCache: true}); } catch (e) {}

                try {
                  UTIL_SERVICE.saveStorage('pointDayIdLast', {id: response.data.id})
                } catch(e) {
                  console.error(e)
                }

                try {
                  response.data.date = response.data.finishedAt;
                } catch (e) {}

                UTIL_SERVICE.saveStorage('dataConfirmPoint', {dataConfirm: response.data});
                try { UTIL_SERVICE.saveStorage('dataDateLastPoint', {date: response.data.finishedAt}); } catch (e) {}

                delete this.dataRegister.baseImage;
                UTIL_SERVICE.historyLog(false, window.location.pathname, 'registerWithLocation', this.dataRegister, false);

                try {
                  if(this.dataInfo.useWorkingLocalUser) {
                    this.sendLocationPoint();
                  }
                } catch (e) {}


                // https://stackoverflow.com/questions/11642926/stop-close-webcam-stream-which-is-opened-by-navigator-mediadevices-getusermedia
                this.stopVideoOnly(this.stream)

                this.$router.push({path: '/confirmacao-de-ponto'});
                this.oneClick = false;
              } else {
                this.loadingRequest = false;
                this.oneClick = false;

                delete this.dataRegister.baseImage;
                UTIL_SERVICE.historyLog(false, window.location.pathname, 'registerWithLocation', this.dataRegister, true, response.data);

                // Show errors.
                let msgError = null;
                response.data.results.permissions.errors.map((value, index) => {

                  if (msgError) {
                    msgError += `, ${value}`;
                  } else {
                    msgError = value;
                  }

                  if (response.data.results.permissions.errors.length === index + 1) {
                    this.$toast.error(msgError)
                  }
                });

                if(response.results.permissions.errors.length) {
                  this.$toast.error(response.results.permissions.errors[0])
                }
              }


              this.oneClick = false;
            }).catch(reason => {
              this.loadingRequest = false;
              console.log(reason)
              this.$toast.error(reason.response.data.results.permissions.errors[0])

              delete this.dataRegister.baseImage;
              UTIL_SERVICE.historyLog(false, window.location.pathname, 'registerWithLocation', this.dataRegister, true);
            });
          }, 2000);
        }
      },
      checkDateHoursFromLastPoint() {
        if (this.currentDateTime) {
          const lastPoint = new moment(new Date(this.dateLastPoint.lastDatePoint)).add(5, 'm').toDate();
          const currentDate = new Date(this.currentDateTime);

          if (currentDate.getTime() > lastPoint.getTime()) {
            if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
              this.showMessageHoliday();
            } else {
              this.sendPointNew();
            }
          } else {
            if (this.needGadgets) {
              if (!this.selectedGadgets) {
                if(this.selectedGadgets.length > 0) {
                  this.loadingRequest = false;
                  this.dataSendError = this.$t("Selecione o local que você está para marcar seu ponto.");
                  this.$toast.error(this.dataSendError)
                  this.oneClick = false
                  return '';
                }

              }
            }

            if (this.needException) {
              if (!this.selectedException) {
                if (this.listException.length > 0) {
                  this.loadingRequest = false;
                  this.dataSendError = this.$t("Selecione o motivo do ponto por exceção para marcar seu ponto.");
                  this.$toast.error(this.dataSendError)
                  this.oneClick = false
                  return '';
                }
              }
            }
            const currentTime = new Date().getTime();
            const timeLastPoint = new Date(this.dateLastPoint.lastDatePoint).getTime() + (5 * 60 * 1000);

            if (currentTime < timeLastPoint) {
              this.showMessage5Minutes();
            } else {
              this.showBlockPage = true;
            }
          }
        } else {
          const lastPoint = new moment(new Date(this.dateLastPoint.lastDatePoint)).add(5, 'm').toDate();
          const currentDate = new Date();

          if (currentDate.getTime() > lastPoint.getTime()) {
            if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
              this.showMessageHoliday();
            } else {
              this.sendPointNew();
            }
          } else {
            this.showMessage5Minutes();
          }
        }
      },
      getListException() {
        REQUEST_SERVICE.get(GET_EXCEPTION).then((response) => {
          UTIL_SERVICE.console("RESULT GET_EXCEPTION:", response.data);
          this.listExceptionLoading = true;

          this.listException = response.data;

          this.listExceptionLoading = false;
        });
      },
      cancelMainLoading() {
       this.loadingSendPoint = false;
      },
      showMessage5Minutes() {
        this.oneClick = false;

        this.isFiveMinutesModalOpened = true;

        if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
          this.showMessageHoliday();
        }
      },
      checkPosition() {
        // Get current position
        return new Promise(function (resolve, reject) {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(resolve, reject, {
              enableHighAccuracy: true,
              timeout: 60000,
              maximumAge: 0
            });
          } else {
            reject({doestSupport: true});
          }
        });
      },
      pointInfo() {
        // Get info from point
        this.loadingInfo = true;
        this.loadingSendPoint = true;

        REQUEST_SERVICE.get(POINT_DAY_DETAIL).then((response) => {
          UTIL_SERVICE.console("RESULT POINT_DAY_DETAIL:", response.data);

          this.dataInfo = response.data;

          if(this.dataInfo.totalPoints) {
            this.configInfoPointCache(response.data.totalPoints);
            try {
              const dataConfigProgressPoint = UTIL_SERVICE.getStorage('configProgressPoint');
              if (dataConfigProgressPoint.newPointRegister > this.dataInfo.totalPoints) {
                this.showPointCache = true;

                // this.myIntervals.updateRefreshPg = setInterval(() => this.updateTimer5Min(), 60000);
              }
            } catch (e) {}
          }
          // if(this.dataInfo.journeyTimes) {
          //   const newArr = this.dataInfo.journeyTimes.split('-').map((e) => {
          //     e.trim()
          //     return e
          //   })
          //   newArr[newArr.length].slice(0, -1)
          //   this.dataInfo.journeyTimes = newArr;
          // }

          this.workedPercentage = response.data.workedHoursPercentage * 100;

          if (this.dataInfo.needLocationToModePointWeb) {
            const getDataLocation = new Promise(function (resolve, reject) {
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(resolve, reject, {
                  enableHighAccuracy: true,
                  timeout: 60000,
                  maximumAge: 0
                });
              } else {
                reject({doestSupport: true});
              }
            });
            getDataLocation.then((response) => {
              this.geoC.latitude = response.coords.latitude;
              this.geoC.longitude = response.coords.longitude;
              this.geoC.elevation = response.coords.altitude;
            });
          }
          this.getTimer();

          this.loadingSendPoint = false;
        }).catch(reason => {
          this.currentDateTime = new Date();
          setInterval(() => this.updateCurrentTime(), 1000);

          this.loadingInfo = false;
          this.loadingSendPoint = false;
        });
      },
      getTimer() {
        // Get Timer from API
        this.loadingInfo = true;
        REQUEST_SERVICE.get(TIMER).then((response) => {
          UTIL_SERVICE.console("RESULT TIMER:", response.data);
          this.loadingInfo = false;
          this.currentDateTime = new Date(response.data);
          this.myIntervals.updateCurrentTime = setInterval(() => this.updateCurrentTime(), 900);
        }).catch(reason => {
          this.loadingInfo = false;
        });
      },
      updateCurrentTime() {
        // Tick to clock
        this.timerBlockPage++;
        this.currentDateTime.setSeconds(this.currentDateTime.getSeconds() + 1);
        this.currentTime = moment(this.currentDateTime, "YYYYMMDD HH:mm").format('HH:mm:ss');

        if (this.timerBlockPage >= 120) {
          this.showBlockPage = true;
        }
      },
      getCamImage() {
        // Get config to show video from webcam
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices.getUserMedia({video: true, audio: false}).then((stream) => {

            this.stream = stream;
            try {
              this.video.srcObject = stream;
            } catch (e) {
              this.video.src = window.URL.createObjectURL(stream);
            }
            this.video.play();
            this.haveCam = true;
          }).catch(err => {
            this.haveCam = false;
          });
        }
      },
      captureCamImage() {
        // Capture Imagem from Webcam
        this.canvas = this.$refs.canvas;
        let context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, 256, 256);
        this.captures = canvas.toDataURL("image/png");
        this.video.pause();
        this.video.src = "";
        // this.stream.getTracks()[0].stop();

        $('#webCamModal').modal('toggle');
      },
      sendLocationPoint() {
        if (this.dataSendLocationPoint.local > 0) {

          let obj = {
            userId: this.dataUserInfo.companyId,
            companyId: this.dataUserInfo.id,
            workingLocal: this.dataSendLocationPoint.local,
            date: moment(new Date()).format("YYYY-MM-DD"),
          }

          UTIL_SERVICE.console("DATA SEND:", obj);
          REQUEST_SERVICE.post(WORKING_LOCAL_EMPLOYEE, obj).then((response) => {
            UTIL_SERVICE.console("RESULT WORKING_LOCAL_EMPLOYEE:", response.data);

          }).catch(reason => {});
        }
      },
      refreshPage() {
        try {
          clearInterval(this.myIntervals.updateCurrentTime);
          clearInterval(this.myIntervals.updateProgressAndHoursWorking);
          this.stream.getTracks()[0].stop();

          this.stopVideoOnly(this.stream)
        } catch (e) {}

        setTimeout(()=>{
          window.location.reload();
        }, 400);
      },
      confirmPoint() {
        $('#modalWorkShift').modal('hide');

        if (this.turnSelected) {
          if (this.dateLastPoint) {
            if (this.dateLastPoint.lastDatePoint) {
              this.checkDateHoursFromLastPoint();
            } else {
              if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
                this.showMessageHoliday();
              } else {
                this.sendPointNew();
              }
            }
          } else {
            if (typeof this.dataInfo.userVacationType !== "undefined" && this.dataInfo.userVacationType !== 0) {
              this.showMessageHoliday();
            } else {
              this.sendPointNew();
            }
          }
        }
      },
      closeModal() {
        $('#modalWorkShift').modal('hide');
        this.turnSelected = ''
      },
      setTurnSelected(value) {
        this.turnSelected = value;
      },
      getWorkingLocalToday() {
        let date = moment(new Date()).format('YYYY-MM-DD');
        let url = WORKING_LOCAL_EMPLOYEE_TODAY + '?date=' + date


        UTIL_SERVICE.console("DATA SEND:", url);
        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT WORKING_LOCAL_EMPLOYEE:", response.data);

          let value = 1

          if(response.data.workingLocal === 2) {
            value = 2
          }
          if(response.data.workingLocal === 3) {
            value = 3
          }

          this.addLocationPoint(value)

        }).catch(reason => {
          this.addLocationPoint(1)
        });
      },
      calculateCircunferenceOffSet(circunference, progress) {
        return circunference * ((100 - progress) / 100);
      },
      calculateCircunferenceDashArray() {
        return 2 * 3.14 * 84;
      }
    },
    mounted() {
      //https://jefrydco.id/en/blog/safe-access-vue-refs-undefined
      const interval = setInterval(() => {
        if(this.$refs.video) {
          if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
           navigator.mediaDevices.getUserMedia({ video: true })
          .then((stream) => {
            this.stream = stream;
            if(this.$refs) {
              this.$nextTick(
                function() {
                  if(this.$refs.video) {
                    this.$refs.video.srcObject = stream;
                  }
                }
              )
            }
          })
          .catch((error) => {
            this.haveCam = false;
            console.error('Error accessing webcam:', error);
          });
        } else {
          this.$toast.error(this.$t("Webcam not supported on this browser"))
        }

          clearInterval(interval)
        }
      }, 50)
    },
    destroyed() {
      this.stopVideoOnly(this.stream)
    }
  }
</script>
<style scoped lang="scss">

  .screen-lock-main-content {
    position: fixed;
    background: var(--opacityBackground);
    height: 100%;
    width: calc(100% - 250px);
    left: 250px;
    top: 0;
    overflow: hidden;
    position: fixed;
    z-index: 5;
  }

  .screen-lock-left-menu {
    position: fixed;
    height: 100%;
    width: 250px;
    top: 0;
    left: 0;
    overflow: hidden;
    position: fixed;
    z-index: 5;
  }
  .webcam-content {
    .cam {
      max-height: 200px;
      padding: 0 20px;
      margin-bottom: 30px;

      canvas {
        display: none;
      }

      video {
        width: 100%;
        max-height: 200px;
        overflow: hidden;
        border-radius: 35px;
        border: 4px solid var(--leftMenuColor);
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
        transition: 0.5s;
      }

      p {
        color: var(--text);
        font-size: 13px;
        text-align: center;
      }
    }
  }
  .register-loader:hover {
    background: var(--bodyColor) !important;
  }
  .modal-workshift {
    padding: 30px;
    box-shadow: none;
    border: none;
    border-radius: 8px;
    width: 532px;

    .modal-header {
      padding: 0 0 10px 0;
      border-bottom: 1px solid var(--bodyColor);

      ion-icon {
        width: 16px;
        height: 16px;
      }

      .close {
        top: 10px;
        right: 10px;
      }

      span {
        color: var(--text);
        font-size: 18px;
        font-weight: 500;
        line-height: 21.2px;
      }
    }

    .modal-body {
      padding: 0;
      .body-content {
        border-bottom: 1px solid var(--bodyColor);

        .content-btn {
          position: relative;
          border-radius: 4px;
          width: 100%;
          margin-bottom: 15px;
          cursor: pointer;
          transition: .2s;

          &:first-child {
            margin-top: 24px;
          }

          .last-point {
            position: absolute;
            top: -10px;
            left: 8px;
            background-color: var(--linkColor);
            color: #FFFFFF;
            padding: 3px 12px;
            font-size: 10px;
            font-weight: 700;
            line-height: 14.06px;
            border-radius: 30px;
          }

          .btn-text {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 12px 0;

            font-size: 14px;
            font-weight: 400;
            line-height: 19.69px;
            color: var(--textSide);

            svg {
              margin-right: 4px;
            }
          }

          .last-appointment {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            position: absolute;
            right: 16px;
            top: 7px;
            color: var(--textSide);

            .last-day {
              font-size: 10px;
              font-weight: 400;
              line-height: 14.06px;
            }

            .last-hour {
              font-weight: 400;
              font-size: 14px;
              line-height: 14px;
            }
          }
        }

        .point-entrance {
          border: 1px solid #2ACC6B;

          &:hover {
            background-color: rgba(42, 204, 107, 0.15);
          }

          &:focus, &:focus-within, &:active {
            background-color: #2ACC6B;

            .btn-text {
              color: #FFFFFF;

              svg {
                path {
                  fill: #FFFFFF;
                }
              }
            }

            .last-appointment {
              color: #FFFFFF;
            }
          }
        }

        .point-exit-interval {
          border: 1px solid #FF9900;

          &:hover {
            background-color: rgba(255, 153, 0, 0.15);
          }

          &:focus, &:focus-within, &:active {
            background-color: #FF9900;

            .btn-text {
              color: #FFFFFF;

              svg {
                path {
                  fill: #FFFFFF;
                }
              }
            }

            .last-appointment {
              color: #FFFFFF;
            }
          }
        }

        .btn-back-interval {
          border: 1px solid #2F23D6;

          &:hover {
            background-color: rgba(47, 35, 214, 0.15);
          }

          &:focus, &:focus-within, &:active {
            background-color: #2F23D6;

            .btn-text {
              color: #FFFFFF;

              svg {
                path {
                  fill: #FFFFFF;
                }
              }
            }

            .last-appointment {
              color: #FFFFFF;
            }
          }
        }

        .point-exit {
          border: 1px solid #FF445D;

          &:hover {
            background-color: rgba(255, 68, 93, 0.15);
          }

          &:focus, &:focus-within, &:active {
            background-color: #FF445D;

            .btn-text {
              color: #FFFFFF;

              svg {
                path {
                  fill: #FFFFFF;
                }
              }
            }

            .last-appointment {
              color: #FFFFFF;
            }
          }
        }
      }

      .footer-content {

        .point-repeat {
          text-align: center;
          margin-top: 8px;
          font-size: 14px;
          font-weight: 400;
          line-height: 19.69px;
          color: #FF445D;
        }

        .content-btn {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 16px;
    margin-right: 15px;
    margin-bottom: 55px;
    border-bottom: 2px solid var(--border);
    padding-bottom: 25px;
    margin-top: 25px;

          .btn-cancel {
            color: var(--text);
            background: var(--leftMenuColor);
            border: 1px solid var(--border);
            transition: .2s;
            cursor: pointer;
            border-radius: 20px;
            height: 33px;
            display: flex;
            padding: 8px 32px;
            justify-content: center;
            align-items: center;
            gap: 10px;
          }

          .btn-confirm {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            background: var(--darkBlue) !important;
            color: #FFFFFF;
            height: 33px;
            border-radius: 20px;
            border: 1px solid var(--darkBlue);
            transition: .2s;
            cursor: pointer;
            font-size: 14px;
            width: 164px;

            ion-icon {
              width: 18px;
              height: 18px;
            }

            svg {
              margin-right: 4px;

              @media only screen and (max-width: 380px) {
                display: none;
              }
            }
          }
        }
      }
    }
  }

  #register-point-loader {
    position: absolute !important;
    top: 0%;
    left: -27%;
  }

  #vacation-modal {
    .confirmation-modal-wrapper {
      ion-icon {
        width: 65px;
        height: 65px;
        color: #9747FF;
      }
    }

    #vacation-text-wrapper {
      display: flex;
      flex-direction: column;
    }
  }

  #five-minutes-modal {

    .five-minutes-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-items: center;
      position: relative;
      height: 85px;
      width: 347.45px;

      ion-icon {
      color: #EDA600;
      height: 65px;
      width: 65px;
      }

      #five-minutes-loader {
        position: absolute;
        top: 30%;
        left: 11%;
      }
    }
  }
  .point-main-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding: 50px 50px 20px 20px;
    margin-right: 47px;
    position: relative;
    flex-wrap: wrap;

    .point-main-left-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 2 0;
      gap: 40px;
      position: relative;
      .screen-lock-cache {
          background: #fff;
          opacity: 0.4;
          height: 480px;
          width: 100%;
          display: block;
          z-index: 6;
          position: absolute;
          top: -73px;
      }
      .left-box-title {
        transition: 0.5s;
        color: var(--text);
        font-weight: 600;
        font-size: 16px;
        text-align: center;
      }

      .icons-wrapper {
        display: flex;
        gap: 38px;
        .left-box-icons {
          transition: 0.5s;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: var(--darkBlue);
          gap: 6px;

          .left-box-locations {
            transition: 0.5s;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            border: 1px solid var(--border);
            border-radius: 15px;
            width: 60px;
            height: 60px;
            color: var(--darkBlue);

            ion-icon {
              height: 40px;
              width: 40px;
            }

            span {
              position: absolute;
              bottom: -31px;
              right: 4px;
            }
          }

          .left-box-locations:hover {
            background: var(--darkBlue);
            color: #fff;
            box-shadow: 3px 3px 4px 0px rgba(0, 0, 0, 0.25) inset;
            transition: 0.3s ease-out;
          }

          .left-box-locations:hover > ion-icon {
            transition: transform 0.3s ease-out;
            transform: scale(0.8);
          }
        }
      }
    }

    .point-main-right-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 2 1 0;
      color: var(--text);

      .point-cache-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;

        #hourglass-point {
          transform: rotate(360deg)
        }

        button {
          transition: 0.5s;
          display: flex;
          padding: 8px 12px;
          gap: 10px;
          border-radius: 20px;
          border: 1px solid var(--darkBlue);
          background: var(--leftMenuColor);
          color: var(--darkBlue);
          min-width: 171px;
          align-items: center;
          justify-content: space-between;

          ion-icon {
            transition: 0.5s;
            color: var(--darkBlue)
          }
        }

        svg {
          path:first-child {
            stroke: var(--darkBlue);
          }

          path:last-child {
            fill: var(--darkBlue);
          }
        }

        span:nth-child(2) {
          color: var(--darkBlue);
          margin-bottom: 17px;
        }

        span:nth-child(3) {
          color: #7E8DA7;

          span{
            font-weight: 600;
          }
        }

        span:nth-child(4) {
          color: #7E8DA7;
          margin-bottom: 17px;
        }
      }

      .title {
        font-size: 16px;
      }

      .last-point {
        font-size: 16px;
        font-weight: 600;
        color: var(--darkBlue);
        margin-bottom: 30px;
      }

      .circle-progress-bar-wrapper {
        position: relative;
        display: flex;
        flex-direction: column;
        margin-bottom: 40px;

        .outer-bar {
          height: 186px;
          width: 186px;
          border-radius: 50%;
          padding: 18px;
          box-shadow: 6px 6px -1px -1px rgba(0, 0, 0, 0.15);
          background: rgba(168, 192, 255, 0.4);

          .inner-bar {
            height: 150px;
            width: 150px;
            border-radius: 50%;
            box-shadow: inset 5px 6px 6px -1px rgba(0,0,0,0.1);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            background: var(--leftMenuColor);
            transition: 0.5s;
            color: var(--text);

            span:nth-child(2) {
              color: var(--darkBlue);
              font-weight: 600;
              font-size: 20px;
              opacity: 1;
            }

            #progress-percentage {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
            }
          }
        }

        .blueGradient {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: conic-gradient(from 90deg, var(--darkBlue) 10%,#A8C0FF 95%);
          animation: pathRotate 7s infinite cubic-bezier(1,1,1,1);
        }
        @keyframes pathRotate {
          0% {  transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        circle {
          transition: 0.5s;
          fill: none;
          stroke: url(#GradientColor);
          stroke-width: 16px;
          stroke-dasharray: 527.52;
          stroke-dashoffset: 0;
          animation: fill 2.5s ease;
        }

        @keyframes fill {
          0% {
            stroke-dashoffset: 527.52;
          }
        }

        svg {
          transition: 0.5s;
          position: absolute;
          top: 0;
          left: 0;
        }
      }

      svg {
        transform: rotate(-90deg)
      }

      .bottom-messages-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;

        .first-line {
          display: flex;
          align-items: center;
          flex-direction: column;
          text-align: center;
          gap: 8px;

          div {
            display: flex;
            align-items: center;
            gap: 8px;

            span {
              flex: 1;
            }
          }

          .journey-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;

            #workshift-times {
              color: var(--darkBlue);
              font-weight: 600;
              margin-bottom: 15px;
            }
          }




          ion-icon {
            color: var(--darkBlue);
          }
        }

        .second-line {
          display: flex;
          align-items: center;
          gap: 8px;
          text-align: center;

          ion-icon {
            color: var(--darkBlue);
          }

          span {
            flex: 1;
          }
        }
      }
    }

    .active {
      background: var(--darkBlue);
      box-shadow: 3px 3px 4px 0px rgba(0, 0, 0, 0.25) inset;

      ion-icon {
        color: #ffffff;
        transform: scale(0.8);
      }
    }

    .mid-line {
      flex: 0;
      transition: 0.5s;
    }
    .mid-line > svg{
      transition: 0.5s;
    }
  }

  .point-main-wrapper > * {
    flex: 1 1 auto;
  }

  #reason-select {
    transition: 0.5s;
    background: url("data:image/svg+xml,<svg height='10px' width='10px' viewBox='0 0 16 16' fill='%23E1E1E1' xmlns='http://www.w3.org/2000/svg'><path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/></svg>") no-repeat !important;
    background-color: var(--leftMenuColor) !important;
    border-radius: 10px !important;
    border: 1px solid var(--defaultText) !important;
    min-width: 300px !important;
    width: 370px;
    height: 36px !important;
    -moz-appearance:none !important;
    -webkit-appearance: none !important;
    appearance: none !important;
    background-position: calc(100% - 0.75rem) center !important;
  }

  #block-modal {
    z-index: 7 !important;
    position: relative;
    span {
      color: var(--text);
      text-align: center;
      max-width: 444px;
    }

    #icon-walk {
      width: 65px;
    height: 65px;
      color: var(--darkBlue)
    }
  }
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/point/newPoint.vue